$(document).on('click', '.js_get-bus', getBus);
$(document).on('click', '.js_tour-disable-order', TourDisableOrder);
$(document).on('click', '.seat:not(.reserved)', clickSeat);
$(document).on('change', '.js_orders-count_places', clickSeat);
$(document).on('click', '.js_form-places-btn', continueOrder);
$(document).on('form-ajax', '.js_form-places', eventPlacesForm);
$(document).on('click', '.js_get-detail', getDetail);
$(document).on('click', '.nf-route-detail-tabs-controls__item', tourTabs);
$(document).on('click', '.js_get-bus-row-bus > .seats-choice', getBus);

function TourDisableOrder() {
    $('html, body').animate({
        scrollTop: $(".blocksWrapper").offset().top
    }, 500);
    let time = $(this).data('time');
    toastr.warning('Бронирование на рейс за ' + time + ' мин до отправления недоступно через сайт, Вы можете забронировать билет с помощью оператора. Благодарим за понимание');
}

function eventPlacesForm(e, response) {
    let form = $(e.target);

    if (response.view) {
        let rowBus = form.closest('.js_get-bus-row-bus');
        rowBus.attr('data-scroll', rowBus.find('.js_bus-wrap').scrollLeft());
        rowBus.html(response.view);
        rowBus.find('.js_bus-wrap').scrollLeft(rowBus.attr('data-scroll'));
    }
    form.closest('.js_get-bus-row').find('.js_bus-overlay').hide();
}

function getBus(e) {

    let self = $(this),
        button = $(e.target);

    if (!self.hasClass('disabled')) {
        let url = self.data('url');
        let returnData = self.data('return')
        let placesData = self.data('places');
        let stationFromId = self.data('station_from_id');
        let stationToId = self.data('station_to_id');
        let baggageType = self.data('baggage_type');
        let oversizedBaggage = self.data('oversized_baggage');
        let $wrapper = self.closest('.js_route').find('.js_get-bus-row');
        let $activeWrapper = self.closest('.nf-routes').find('.js_get-bus-row.active');
        let $newRoute = $wrapper.closest('.nf-route');

        if (!$wrapper.hasClass('active')) {
            $activeWrapper.removeClass('active');
            $.post(url, { return_ticket: returnData, places: placesData, station_from_id: stationFromId, station_to_id: stationToId, baggage_type: baggageType, oversized_baggage: oversizedBaggage  }, function (response) {
                if (response.result == 'success') {
                    if ($newRoute) {
                        $wrapper.prev().remove();
                    }
                    $wrapper
                        .show()
                        .addClass('active');
                    $wrapper.find('.js_get-bus-row-bus').html(response.view);
                    if ($wrapper.find('.js_orders-count_places').length && (window.innerWidth < 992)) {
                        button.attr('disabled', 'disabled');
                        $wrapper.hide();
                        $wrapper.find('.js_form-places-btn').trigger('click');
                    } else {
                        if (!$newRoute) {
                            $wrapper.find('.js_orders-count_places').trigger('change');
                        }
                    }
                    //$wrapper.find('.js_orders-count_places').trigger('change');
                } else {
                    toastr.error(response.message);
                }
            });
        } else {
            $wrapper.removeClass('active').hide();
        }
    }
    return false;
}

function continueOrder() {
    $wrapper = $(this).closest('.js_route').find('.js_get-bus-row');
    $newRoute = $wrapper.closest('.nf-route');
    let order = true;

    if ($('#return_flag > option:selected').val() === '1') {
        let returnBlockName = '.scheduleBlockReturn';
        let places = $('.scheduleBlock .js_get-bus-row-bus .cell.active:visible').length + parseInt($('.scheduleBlock .js_orders-count_places').val() || 0);  // Кол-во мест туда
        let places2 = $('.scheduleBlockReturn .js_get-bus-row-bus .cell.active:visible').length + parseInt($('.scheduleBlockReturn .js_orders-count_places').val() || 0); // Кол-во мест обратно

        if (places2 == 0 && places > 0) {
            $('.scheduleBlock').fadeOut();
            order = false;
        }

        if (places == 0 && places2 > 0) {
            //$('.scheduleBlockReturn ').fadeOut();
            order = false;
        }

        if (!$newRoute) {
            if (places !== places2) {
                toastr.error('Количество мест туда и обратно должны совпадать!');
                return false;
            }
            if (places == 0) {
                toastr.error('Выберите места!');
                return false;
            }
        }

        //для бронирования без мест (т.к. создание брони идёт по клику на место, а без выбора, создания брони не происходит)
        if ($('.seats-count').length) {
            if ($(this).closest('.scheduleBlockReturn').length) {
                clickSeat(true, $(this));
                return false;
            } else {
                clickSeat(false, $(this));
            }
        }

        //Условие для билетов туда/обратно
        if ($(this).closest('.scheduleBlockReturn').length) {
            window.location.href = "/order";
            return false;
        } else {
            return false;
        }
    }
    clickSeat(order, $(this));
}

function clickSeat(order, $this) {
    $this = $this ? $this : $(this);
    let $wrapper = $this.closest('.js_get-bus-row');
    let $form = $wrapper.find('.js_form-places');
    let $wrapperInput = $form.find('.js_form-places-inputs')
    $wrapper.find('.js_bus-overlay').show()
    $wrapperInput.html('');
    $wrapperInput.prepend('<input type="hidden" name="return_ticket" value="' + $this.closest('.nf-route').find('.reservationButton').eq(0).data('return') + '"/>');
    var $countPlaces = $wrapper.find('.js_orders-count_places');

    if ($countPlaces.length) {
        let val = $countPlaces.val();
        for (let $i = 0; $i < val; $i++) {
            $wrapperInput.prepend(`<input type="hidden" name="places[]" value=""/>`);
        }
    } else {
        if (parseInt(cnt_reserved_places_tour) >= parseInt(limit_order_by_place) &&
            $(this).hasClass('active') !== true && order !== true
        ) {
            toastr.error("Бронирование ограничено");
        } else $(this).toggleClass('active');

        $wrapper.find('.seat.active:not(.reserved)').each(function () {
            if (!$(this).hasClass('reserveddispatcher') && !$(this).hasClass('reservedintegrator')) {
                let number = $(this).data('number');
                $wrapperInput.prepend(`<input type="hidden" name="places[]" value="${number}"/>`);
            } else {
                let number = $(this).data('number');
                if ( $(this).hasClass('reserveddispatcher') ) toastr.error('Место №' + number + ' в квоте у диспетчера');
                if ( $(this).hasClass('reservedintegrator') ) toastr.error('Место №' + number + ' в квоте у интегратора');
            }
        })
    }
    if (order === true) $form.addClass('js_form-step-order')
    $form.submit();
    return false;
}

function getDetail() {
    let detailBlock = $(this).closest('.nf-route').find('.nf-route-detail');

    detailBlock.find('.nf-route-detail-tabs-controls__item:first-child').trigger('click');
    detailBlock.slideToggle();
}

function tourTabs() {
    let index = $(this).index();

    $(this).addClass('is-active').siblings('.is-active').removeClass('is-active');
    $(this).closest('.nf-route-detail').find('.nf-route-detail-tabs-container-item').eq(index).addClass('is-show').siblings('.is-show').removeClass('is-show');
}



